import CloseIcon from '@mui/icons-material/Close';
import { Modal, Button, IconButton, Input } from '@mui/material';
import FormControlLabel from '@mui/material/FormControlLabel';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import TextField from '@mui/material/TextField';
import { Dispatch, SetStateAction, useState } from 'react';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/bootstrap.css';

interface EditUserModalProps {
  fetchSubadmins: () => Promise<void>;
  handleUserUpdate: (id: string, status: any, type: string) => void;
  flag: boolean;
  setFlag: React.Dispatch<React.SetStateAction<boolean>>;
  handleProfileUpload: any;
  selectedImage: any;
  setSelectedImage: any;
  roles: any;
  handleSubmit: any;
  open: boolean;
  onClose: () => void;

  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  name: string;
  setName: Dispatch<SetStateAction<string>>;
  email: any;
  setEmail: any;
  phone: any;
  setPhone: React.Dispatch<React.SetStateAction<string>>;
  dialCode: any;
  setDialCode: React.Dispatch<React.SetStateAction<any>>;
  handleChangePhone: any;
  selectedRole: any;
  setSelectedRole: React.Dispatch<React.SetStateAction<any>>;
  profileImage?: any;
  setProfileImage?: Dispatch<SetStateAction<string>>;
  selectedId: any;
  openEdit: boolean;
  setOpenEdit: Dispatch<SetStateAction<boolean>>;
}

export default function EditUser({
  open,
  onClose,
  setOpen,
  handleProfileUpload,
  selectedImage,
  setSelectedImage,
  roles,
  handleSubmit,
  name,
  setName,
  email,
  setEmail,
  phone,
  setPhone,
  dialCode,
  setDialCode,
  handleChangePhone,
  selectedRole,
  setSelectedRole,
  setOpenEdit,
}: EditUserModalProps) {
  // Validation function
  const validateForm = () => {
    setError(false);

    if (!name || !email || !phone || !selectedRole) {
      setError(true);
      return false;
    }

    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      setError(true);
      return false;
    }

    if (phone.length <= 5) {
      setError(true);
      return false;
    }

    return true;
  };

  // Handle form submission
  const handleFormSubmit = () => {
    if (validateForm()) {
      handleSubmit();
      setOpenEdit(false);
    }
  };

  const [error, setError] = useState(false);

  return (
    <Modal
      className="modal addUser_modal"
      id="addUserModal"
      aria-labelledby="addUser-modal-title"
      aria-describedby="addUser-modal-description"
      open={open}
      onClose={onClose}
    >
      <div className="modal-dialog">
        <div className="modal-body">
          <div
            className="btn-close"
            onClick={() => {
              setName('');
              setEmail('');
              setPhone('');
              setDialCode('');
              setSelectedRole('');
              setSelectedImage('');
              setOpen(false);
            }}
          >
            <CloseIcon />
          </div>
          <div className="modal_title">
            <h2>Edit Subadmin</h2>
            <p>Send access to a user by filling the below details</p>
          </div>
          <form className="form">
            <div className="gap_p">
              <div className="control_group w_100">
                <div className="upload_box">
                  <label>
                    {selectedImage && (
                      <IconButton className="crossIcon" onClick={() => setSelectedImage('')}>
                        <CloseIcon />
                      </IconButton>
                    )}
                    <figure>
                      <img
                        src={selectedImage ? selectedImage : '/static/images/user_attachmen2.jpg'}
                        alt="Upload"
                      />
                    </figure>
                    <IconButton className="uploadIcon">
                      <label htmlFor="icon-button-file">
                        <Button component="span" className="upload_image_btn">
                          <img src="/static/images/edit2_icon.svg" alt="Upload" />
                          <Input
                            sx={{ display: 'none' }}
                            id="icon-button-file"
                            type="file"
                            inputProps={{
                              accept: 'image/png,image/jpeg',
                            }}
                            onChange={(e: any) => {
                              handleProfileUpload(e);
                              e.target.value = null;
                            }}
                          />
                        </Button>
                      </label>
                    </IconButton>
                  </label>
                </div>
              </div>
              <div className="control_group w_50">
                <label>Name</label>
                <TextField
                  variant="outlined"
                  placeholder="Full name"
                  fullWidth
                  hiddenLabel
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                />
                {error && !name && <h6 className="err_msg">Name is required</h6>}
              </div>
              <div className="control_group w_50">
                <label>E-mail</label>
                <TextField
                  variant="outlined"
                  placeholder="Enter here"
                  fullWidth
                  hiddenLabel
                  value={email}
                  onChange={(val) => {
                    if (val.target.value === ' ' || val.target.value === '.') {
                    } else {
                      setEmail(val.target.value);
                    }
                  }}
                />
                {error && !email && <h6 className="err_msg">Email is required</h6>}
                {error && email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email) && (
                  <h6 className="err_msg">Please enter a valid email address!</h6>
                )}
              </div>
              <div className="control_group w_100">
                <label>Phone Number</label>
                <PhoneInput
                  enableSearch
                  value={dialCode + phone}
                  country={'uae'}
                  inputClass="phoneInput"
                  onChange={(phone, country) => handleChangePhone(phone, country)}
                  inputStyle={{ width: '100%' }}
                  buttonClass="phoneBtn"
                  placeholder="Phone Number"
                />
                {error && !phone && <h6 className="err_msg">Phone number is required</h6>}
                {error && phone && phone.length <= 5 && (
                  <h6 className="err_msg">Phone number must contain at least 6 digits</h6>
                )}
              </div>
            </div>

            {/* Role Section */}
            <h3>Role</h3>
            <ul className="roles_list">
              <RadioGroup value={selectedRole} onChange={(e) => setSelectedRole(e.target.value)}>
                {roles?.length
                  ? roles.map((role: any) => (
                      <FormControlLabel
                        key={role._id}
                        value={role._id}
                        control={<Radio />}
                        label={role.name}
                      />
                    ))
                  : null}
              </RadioGroup>
              {error && !selectedRole && <h6 className="err_msg">Role is required</h6>}
            </ul>

            {/* Action Buttons */}
            <div className="footer_btn_flex">
              <Button
                className="btn btn_highlight"
                onClick={() => {
                  setError(false);
                  setOpen(false);
                  setName('');
                  setEmail('');
                  setPhone('');
                  setDialCode('');
                  setSelectedRole('');
                  setSelectedImage('');
                  // setProfileImage("");
                }}
              >
                Cancel
              </Button>
              <Button
                className="btn btn_secondary"
                onClick={() => {
                  handleFormSubmit();
                }}
              >
                Update
              </Button>
            </div>
          </form>
        </div>
      </div>
    </Modal>
  );
}
